import { createContext } from "react";
import type { User } from "firebase/auth";

export interface AuthContextType {
    userFirebase: User | null;
    loading: boolean;
    error: boolean;
}

export const AuthContext = createContext<AuthContextType | null>(null);
